import fetchAPI from '../fetchAPI';

interface CallSetBillApprovalProps {
  id: string;
  kind: 'invoice' | 'report';
  action: 'approve' | 'decline';
  approvedByUserId: string;
  via: 'slack' | 'admin';
  reason?: string | null;
}

export const callSetBillApproval = async (
  { id, ...body }: CallSetBillApprovalProps
): Promise<iResponse<Bill>> => {
  const response: iResponse<Bill> = await fetchAPI({
    method: `POST`,
    route: `bills/${id}/approval`,
    data: body
  });
  return response;
};

export default callSetBillApproval;
